import React, {FunctionComponent, useEffect, useLayoutEffect, useState,} from "react";
import {makeStyles} from "tss-react/mui";
import {STATIC_COL_WIDTH} from "../../Constants";
import moment from "moment/moment";
import {IconButton, Theme, Tooltip} from "@mui/material";
import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
import {CHANGE_DATES_START, SET_SINGLE_DAY_PREVIOUS_STARTDATE} from "../../../../Redux/Disposition/Constants";
import {useAppDispatch, useAppSelector} from "../../../../Redux/Redux";
import {useSelector} from "react-redux";
import {selectSidebarIsOpen} from "../../../../Redux/App/AppReducer";
import {ActualTimeLine} from "./ActualTimeLine";
import {useTranslation} from "../../../../Utils/CustomHooks/useTranslation";

interface DispositionDateHeaderMainProps {
    startdate: string;
    dispoDaysAfter: any;
    dispoDaysBefore: any;
    contentWidth: number | undefined;
    setHeight: any;
    dispositionControlsPositionTop: any;
    viewData: any;
    holidays: any;
}

const useStyles = makeStyles()((theme: Theme) => ({
    dispositionHeaderMain: {
        display: "flex",
    },

    dispositionHeaderTh: {
        width: STATIC_COL_WIDTH,
        position: "fixed",
        display: "flex",
        zIndex: 400,
        height: 90,
        paddingTop: 15,
        paddingLeft: 15,
        paddingRight: 15,
    },

    vehicleInfo: {
        flex: "1 1",
    },

    extrasInfo: {
        flex: "1 1",
    },

    groupInfo: {
        flex: "1 1",
        textAlign: "right",
        display: "flex",
        justifyContent: "flex-end",
    },

    dispositionLines: {
        borderLeft: "1px solid 	#000000",
    },

    currentDay: {
        backgroundColor: "rgba(128,201,243,.2)",
    },

    dispositionHeaderDates: {
        position: "fixed",
        display: "flex",
        zIndex: 400,
        height: 90,
        paddingTop: 5,
        background: theme.palette.background.default,
    },

    dispositionHeaderDate: {
        borderLeft: "1px solid 	#000000",
        textAlign: "center",
        marginLeft: "auto",
        marginRight: "auto",
        //marginTop: '45px',
        //transform: "rotate(45deg)"
    },
}));

const DispositionDateHeaderMain: FunctionComponent<
    DispositionDateHeaderMainProps
> = ({
         startdate,
         dispoDaysAfter,
         contentWidth,
         setHeight,
         dispositionControlsPositionTop,
         holidays,
                                          viewData
     }): JSX.Element => {
    if (contentWidth === undefined) {
        contentWidth = 0;
    }

    const {
        singleDayPreviousStartdate
    } = useAppSelector((state) => state.disposition);

    const [prevDay, setPrevDay] = useState(singleDayPreviousStartdate);
    const [dayOffset, setDayOffset] = useState(0);
    const [updatedContentWidth, setUpdatedContentWidth] = useState(0);
    const [isUpdated, setIsUpdated] = useState(0);

    const {classes, css, cx} = useStyles();
    const {days, hours, dayWidth} = useAppSelector(
        (state) => state.disposition,
    );
    const colors = viewData?.colorList?.colors;

    const {t} = useTranslation();

    const [prevDays, setPrevDays] = useState(days);

    const dispatch = useAppDispatch();

    const sidebarIsOpen = useSelector((state) => selectSidebarIsOpen(state));

    const retryUpdateContentWidthIsNaN = () => {
        if (!isNaN(parseInt(document.getElementById("dispo_content")?.style.width))) {
            setUpdatedContentWidth(
                parseInt(document.getElementById("dispo_content")?.style.width),
            );
            setIsUpdated(true);
        } else {
            setTimeout(() => {
                retryUpdateContentWidthIsNaN()
            }, 100);
        }
    }

    useLayoutEffect(() => {
        setHeight(
            document.getElementById("disposition_header_info")?.clientHeight ||
            0,
        );
        setIsUpdated(false);
        setTimeout(() => {
            retryUpdateContentWidthIsNaN()
        }, 1);
    }, [sidebarIsOpen, days, document.body.clientWidth]);

    useEffect(() => {
        if (days > 1 && prevDays != days) {
            setPrevDays(days);
        }
    }, [days]);
    const getDispositionLines = () => {
        const content = [];

        if (days > 1) {
            for (let i = 0; i < days; i++) {
                content.push(
                    <div
                        key={"line-day" + i}
                        style={{width: dayWidth + "%"}}
                        className={cx(classes.dispositionLines, {
                            [classes.currentDay]: getCurrent(i),
                        }, {
                            [css({backgroundColor: colors?.find((color: any) => color.code == "RES_COL_WEEKEND")?.color})]: isWeekend(i)
                        }, {
                            [css({backgroundColor: colors?.find((color: any) => color.code == "RES_COL_FEIERTAG")?.color})]: isHoliday(i)
                        })}
                    />,
                );
            }
        } else {
            for (let i = 0; i < hours; i++) {
                content.push(
                    <div
                        key={"line-hour" + i}
                        style={{width: dayWidth + "%"}}
                        className={classes.dispositionLines}
                    />,
                );
            }
        }

        return content;
    };

    const getCurrent = (index: number) => {
        const today = moment()
            .utc()
            .hours(0)
            .minutes(0)
            .seconds(0)
            .milliseconds(0);
        const actualDispoDate = moment(startdate)
            .utc()
            .hours(0)
            .minutes(0)
            .seconds(0)
            .milliseconds(0)
            .add(index, "days");

        return actualDispoDate.isSame(today);
    };

    const isWeekend = (index: number) => {
        const date = moment(startdate)
            .utc()
            .hours(0)
            .minutes(0)
            .seconds(0)
            .milliseconds(0)
            .add(index, "days");

        return date.weekday() == 5 || date.weekday() == 6;
    }

    const isHoliday = (index: number) => {
        const date = moment(startdate)
            .utc()
            .hours(0)
            .minutes(0)
            .seconds(0)
            .milliseconds(0)
            .add(index, "days")
            .format('YYYY-MM-DD HH:mm:ss.SSS');

        return holidays?.find((holiday) => holiday.date == date) != undefined;
    }

    const getHolidayOccasion = (index: number) => {
        const date = moment(startdate)
            .utc()
            .hours(0)
            .minutes(0)
            .seconds(0)
            .milliseconds(0)
            .add(index, "days")
            .format('YYYY-MM-DD HH:mm:ss.SSS');

        return holidays?.find((holiday) => holiday.date == date).occasion;
    }

    const getTooltipText = (index) => {
        if (isHoliday(index)) {
            return getHolidayOccasion(index);
        }

        if (isWeekend(index)) {
            return t("general.weekend");
        }

        return "";
    }

    const getPositionHeaderDate = () => {
        const content = [];

        if (days > 1) {
            for (let i = 0; i < days; i++) {
                content.push(
                    <Tooltip title={getTooltipText(i)} key={"day" + i}>
                        <div
                            style={{ width: dayWidth + "%" }}
                            className={cx(classes.dispositionHeaderDate, {
                                [classes.currentDay]: getCurrent(i),
                            }, {
                                [css({backgroundColor: colors?.find((color: any) => color.code == "RES_COL_WEEKEND")?.color})]: isWeekend(i)
                            }, {
                                [css({backgroundColor: colors?.find((color: any) => color.code == "RES_COL_FEIERTAG")?.color})]: isHoliday(i)
                            })}
                        >
                            {sidebarIsOpen &&
                                getCurrent(i) &&
                                document.getElementById("dispo_content") &&
                                isUpdated && (
                                    <ActualTimeLine
                                        dayWidth={dayWidth}
                                        startOffset={
                                            (updatedContentWidth / 100) *
                                            dayWidth *
                                            i
                                        }
                                        contentWidth={
                                            updatedContentWidth == 0
                                                ? parseInt(
                                                    document.getElementById(
                                                        "dispo_content",
                                                    ).style.width,
                                                )
                                                : updatedContentWidth
                                        }
                                        singleDay={false}
                                    />
                                )}
                            {!sidebarIsOpen &&
                                getCurrent(i) &&
                                document.getElementById("dispo_content") &&
                                isUpdated && (
                                    <ActualTimeLine
                                        dayWidth={dayWidth}
                                        startOffset={
                                            (updatedContentWidth / 100) *
                                            dayWidth *
                                            i
                                        }
                                        contentWidth={updatedContentWidth}
                                        singleDay={false}
                                    />
                                )}
                            <div
                                style={{
                                    transform: "rotate(45deg)",
                                    fontSize: days > 14 ? "0.75rem" : "1rem",
                                }}
                            >
                                {days <= 14 && (
                                    <>
                                        {moment(startdate)
                                            .utc()
                                            .add(i, "days")
                                            .format("dd")}
                                    </>
                                )}
                                <br/>
                                {moment(startdate)
                                    .utc()
                                    .add(i, "days")
                                    .format("DD.MM")}
                            </div>
                            <Tooltip
                                title={t(
                                    "disposition.dateHeader.selectSingleDayButtonLabel",
                                )}
                            >
                                <IconButton
                                    size="small"
                                    style={{marginLeft: -6}}
                                    onClick={() => {
                                        dispatch({
                                            type: SET_SINGLE_DAY_PREVIOUS_STARTDATE,
                                            payload: {
                                                singleDayPreviousStartdate: moment(startdate).utc()
                                            },
                                        });

                                        setDayOffset(i);
                                        dispatch({
                                            type: CHANGE_DATES_START,
                                            payload: {
                                                dispositionStartdate: moment(
                                                    startdate,
                                                )
                                                    .utc()
                                                    .add(i, "days"),
                                                dispositionEnddate: moment(
                                                    startdate,
                                                )
                                                    .utc()
                                                    .add(i, "days"),
                                            },
                                        });
                                    }}
                                >
                                    <SwapHorizIcon/>
                                </IconButton>
                            </Tooltip>
                        </div>
                    </Tooltip>,
                );
            }
        } else {
            for (let i = 0; i < hours; i++) {
                content.push(
                    <div
                        key={"hour" + i}
                        style={{width: dayWidth + "%"}}
                        className={classes.dispositionHeaderDate}
                    >
                        {i < 10 ? "0" + i + ":00" : i + ":00"}
                        {i == 0 && (
                            <Tooltip
                                title={t(
                                    "disposition.dateHeader.selectPreviousDaysButtonLabel",
                                )}
                            >
                                <IconButton
                                    size="small"
                                    style={{marginLeft: -6}}
                                    onClick={() => {
                                        dispatch({
                                            type: CHANGE_DATES_START,
                                            payload: {
                                                dispositionStartdate: moment(prevDay).format() != "Invalid date" ? prevDay : singleDayPreviousStartdate,
                                                dispositionEnddate: moment(
                                                    singleDayPreviousStartdate,
                                                )
                                                    .utc()
                                                    .add(
                                                        dispoDaysAfter < 1 ? 1 : dispoDaysAfter,
                                                        "days",
                                                    ),
                                            },
                                        });
                                    }}
                                >
                                    <SwapHorizIcon/>
                                </IconButton>
                            </Tooltip>
                        )}
                    </div>,
                );
            }
        }

        return content;
    };

    const renderTimeLine = () => {
        if (dayWidth == 0) {
            return <></>;
        }

        if (days == 1 && getCurrent(0)) {
            if (sidebarIsOpen) {
                return (
                    <ActualTimeLine
                        dayWidth={dayWidth}
                        startOffset={0}
                        contentWidth={contentWidth}
                        singleDay={true}
                    />
                );
            } else {
                return (
                    <ActualTimeLine
                        dayWidth={dayWidth}
                        startOffset={0}
                        contentWidth={contentWidth}
                        singleDay={true}
                    />
                );
            }
        }
    };

    const controlsHeight =
        document.getElementById("dispo-controls-main")?.clientHeight || 0;

    return (
        <>
            <div
                id="disposition__header"
                className={classes.dispositionHeaderMain}
            >
                <div
                    className={classes.dispositionHeaderTh}
                    id={"disposition_header_info"}
                    style={{
                        top: dispositionControlsPositionTop + controlsHeight,
                    }}
                >
                    <div className={classes.vehicleInfo}>
                        {t("disposition.dateHeader.vehicleInfoLabel")}
                    </div>
                    <div className={classes.extrasInfo}>
                        {t("disposition.dateHeader.extrasInfoLabel")}
                    </div>
                    <div className={classes.groupInfo}>
                        {t("disposition.dateHeader.groupInfoLabel")}
                        <br/>
                        {t("disposition.dateHeader.kilometersInfoLabel")}
                        <br/>
                        {t("disposition.dateHeader.kmActualPlanLabel")}
                    </div>
                </div>
                <div
                    id={"dispo_content"}
                    style={{
                        display: "flex",
                        right: "6px",
                        position: "absolute",
                        height: "100%",
                        width: contentWidth - STATIC_COL_WIDTH,
                        top: dispositionControlsPositionTop + controlsHeight,
                    }}
                >
                    {getDispositionLines()}
                    <div
                        style={{
                            width: contentWidth - STATIC_COL_WIDTH + "px",
                            top:
                                dispositionControlsPositionTop +
                                controlsHeight +
                                "px",
                        }}
                        className={classes.dispositionHeaderDates}
                    >
                        {getPositionHeaderDate()}
                        {renderTimeLine()}
                    </div>
                </div>
            </div>
        </>
    );
};

export default DispositionDateHeaderMain;
